module.exports = __webpack_public_path__ + "static/media/8M.a3313ad4.png";